import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const carRepository = RepositoryFactory.get("car");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setCar(state, payload) {
    state.data = payload;
  },
  setCarDetail(state, payload) {
    state.detailData = payload;
  },
  setSuccessObject(state, payload) {
    state.successObject = payload;
  }
};
const actions = {
  async loadCar(context) {
    const cars = await carRepository.list();
    if (cars.status < 300) {
      context.commit("setCar", cars.data);
    }
  },
  async loadCarDetail(context, payload) {
    const requestParameter = {
      car_id: payload.carId
    };
    const carDetails = await carRepository.detail(
      payload.screenId,
      requestParameter
    );
    if (carDetails.status < 300) {
      context.commit("setCarDetail", carDetails.data);
      context.commit("setSuccessObject", carDetails);
    }
  },
  async entryCar(context, payload) {
    const requestParameter = {
      carop_id: payload.car.carop_id,
      car_type: payload.car.car_type,
      car_limit: payload.car.car_limit,
      car_number_area: payload.car.car_number.area,
      car_number_cls: payload.car.car_number.class,
      car_number_kana: payload.car.car_number.kind,
      car_number_series: payload.car.car_number.number,
      car_number_special: payload.car.car_number.special
    };
    const cars = await carRepository.entry(payload.screenId, requestParameter);
    if (cars.status < 300) {
      context.commit("setSuccessObject", cars);
    }
  },
  async updateCar(context, payload) {
    const requestParameter = {
      car_id: payload.car.car_id,
      carop_id: payload.car.carop_id,
      car_type: payload.car.car_type,
      car_limit: payload.car.car_limit,
      car_number_area: payload.car.car_number.area,
      car_number_cls: payload.car.car_number.class,
      car_number_kana: payload.car.car_number.kind,
      car_number_series: payload.car.car_number.number,
      car_number_special: payload.car.car_number.special,
      modified_hash: payload.car.modified_hash
    };
    const cars = await carRepository.update(payload.screenId, requestParameter);
    if (cars.status < 300) {
      context.commit("setSuccessObject", cars);
    }
  },
  async deleteCar(context, payload) {
    const requestParameter = {
      car_id: payload.car.car_id,
      modified_hash: payload.car.modified_hash
    };
    const cars = await carRepository.delete(payload.screenId, requestParameter);
    if (cars.status < 300) {
      context.commit("setSuccessObject", cars);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
